/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringSalaryAggregateDto } from '../../models/backend-monitoring-salary-aggregate-dto';

export interface MonitoringScenariosOpexesSalariesRetrieve$Params {
  scenario_id: number;
}

export function monitoringScenariosOpexesSalariesRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosOpexesSalariesRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMonitoringSalaryAggregateDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosOpexesSalariesRetrieve.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMonitoringSalaryAggregateDto>;
    }),
  );
}

monitoringScenariosOpexesSalariesRetrieve.PATH = '/api/monitoring/scenarios/{scenario_id}/opexes/salaries/';
